import React from 'react';
import { observer } from 'mobx-react';
import { CommonPopupBodyFooterLayout } from '../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../global/sub-window/common/common-close-sub-window-buttons';
import { OperatorsBulkUpdateFormViewModel } from './operators-bulk-update-form.viewmodel';
import OperatorsBulkUpdateFormBodyPresentation from './operators-bulk-update-form-body-presentation';
import { applyText, cancelText } from '../../../../../constants/common-labels.constants';
import './operators-bulk-update-form.scss';

const OperatorsBulkUpdateFormPresentation = observer((props: { vm: OperatorsBulkUpdateFormViewModel }) => {
    const formVM = props.vm;

     return (
        <CommonPopupBodyFooterLayout
            body={<OperatorsBulkUpdateFormBodyPresentation
                formVM={formVM}
                intl={formVM.intl}
            />}
            footer={
                <>
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={applyText()}
                            modifier={['fat', 'confirm-safe']}
                            onClick={formVM.bulkUpdateOperatorsApiCall.bind(formVM)}
                        />
                        <DefaultCloseSubWindowButton
                            text={cancelText()}
                        />
                    </div>
                </>
            }
        />
    );
});

export default OperatorsBulkUpdateFormPresentation;
